import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import Loader from "@/components/widgets/loader.vue";
// SYSTEMONE
import BaseMixer from "@/router/views/BaseMixer";
import { Guid } from "guid-typescript";
import { PAStepModule } from "@/store/modules/paStep.module";
import stepMachine from "../machines/stepsMachine";
import { PAStepModel } from "@/store/models/paStep/paStepDTO";
import Switches from "vue-switches";
import { interpret } from "xstate";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
let StepUpsertComponent = /** @class */ (() => {
    let StepUpsertComponent = class StepUpsertComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.mode = "";
            this.selectedAudience = "";
            this.step = new PAStepModel();
            this.userName = "";
            this.role = "";
            this.targetAudienceId = "";
            this.showAdd = false;
            this.machine = stepMachine.withContext({
                stepId: Guid.createEmpty(),
                mode: "",
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        clearStep() {
            this.$bvModal.hide("review-step");
            this.machineService.send({ type: "CANCEL_STEP" });
            this.role = "";
            this.userName = "";
            this.resetStep();
        }
        resetStep() {
            for (const prop in this.step) {
                if (this.step.hasOwnProperty(prop)) {
                    this.step[prop] = PAStepModel.prototype[prop];
                }
            }
        }
        showModal(mode, stepId) {
            this.showAdd = true;
            this.$bvModal.show("review-step");
            this.mode = mode;
            this.machineService.send({ type: "SHOW_STEP", mode: mode, stepId: stepId });
        }
        showInternalAudience() {
            this.machineService.send({ type: "INTERNAL_STAKE_HOLDER" });
        }
        showExternalAudience() {
            this.machineService.send({ type: "EXTERNAL_STAKE_HOLDER" });
        }
        selectAudience(audience) {
            this.selectedAudience = audience.value;
            this.step.targetAudienceId = audience.id;
            let type;
            switch (audience.value) {
                case "By User":
                    type = "BY_USER";
                    this.role = "";
                    break;
                case "By Role":
                    type = "BY_ROLE";
                    this.userName = "";
                    break;
                case "By ReportingTo":
                    type = "BY_REPORTING_TO";
                    this.emptyAudienceDetails();
                    break;
                case "By ClientContact":
                    this.emptyAudienceDetails();
                    break;
                default:
                    break;
            }
            this.machineService.send({ type });
        }
        get filteredTargetAudiences() {
            if (this.step.isInternalStakeholder) {
                return this.targetAudiences.filter((audience) => audience.isSelected);
            }
            else {
                return this.targetAudiences.filter((audience) => !audience.isSelected);
            }
        }
        assigntargetAudience(name) {
            return this.targetAudiences.find((x) => x.value === name);
        }
        get steps() {
            return PAStepModule.step;
        }
        get isRoleRequired() {
            return this.state.matches("internalStakeHolder.byRole");
        }
        get isUserRequired() {
            return this.state.matches("internalStakeHolder.byUser");
        }
        saveStep() {
            this.validate("newStepObserver").then((response) => {
                if (response) {
                    if (this.userName !== "") {
                        const foundEmployee = this.findEmployeeByUsername(this.userName);
                        if (foundEmployee) {
                            this.step.userId = foundEmployee.id;
                        }
                    }
                    if (this.role !== "") {
                        const foundRole = this.findRoleByName(this.role);
                        if (foundRole) {
                            this.step.roleId = foundRole.id;
                        }
                    }
                    this.step.defaultDuration = parseInt(this.step.defaultDuration.toString());
                    if (this.mode == "Edit") {
                        this.machineService.send({ type: "EDIT_STEP", item: this.step });
                    }
                    else {
                        this.machineService.send({ type: "SAVE_STEP", item: this.step });
                    }
                }
            });
        }
        findRoleByName(roleName) {
            return this.roles.find((role) => role.value.toLowerCase().replace(/\s/g, "") === roleName.toLowerCase().replace(/\s/g, ""));
        }
        findEmployeeByUsername(username) {
            return this.employees.find((employee) => employee.value.toLowerCase().replace(/\s/g, "") === username.toLowerCase().replace(/\s/g, ""));
        }
        emptyAudienceDetails() {
            this.userName = "";
            this.role = "";
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.previousState = this.state;
                this.state = state;
                if (state.matches("internalStakeHolder")) {
                    this.step.defaultDuration = 2;
                }
                if ((this.mode == "Add" && this.showAdd == true) || (this.previousState.matches("externalStakeHolder") && state.matches("internalStakeHolder.byRole"))) {
                    this.step.isInternalStakeholder = true;
                    this.selectAudience(this.assigntargetAudience("By Role"));
                    this.showAdd = false;
                }
                if (state.matches("externalStakeHolder")) {
                    this.selectAudience(this.assigntargetAudience("By ClientContact"));
                }
                if (this.previousState.matches("savingStep") && this.state.matches("modalDormant")) {
                    this.emptyAudienceDetails();
                    this.clearStep();
                }
                if (this.previousState.matches("updatingStep") && this.state.matches("modalDormant")) {
                    this.emptyAudienceDetails();
                    this.clearStep();
                }
                if (this.previousState.matches("gettingStepDetails") && this.state.matches("loadedStep")) {
                    this.step = this.steps;
                    this.selectedAudience = this.step.targetAudienceName;
                    if (this.step.targetAudienceName == "By Role") {
                        this.role = this.step.audienceDetailName;
                    }
                    if (this.step.targetAudienceName == "By User") {
                        this.userName = this.step.audienceDetailName;
                    }
                }
            });
        }
        addFocus() {
            if (this.mode == "Add") {
                this.setFocusToInput("addFormFocus");
            }
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], StepUpsertComponent.prototype, "targetAudiences", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], StepUpsertComponent.prototype, "employees", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], StepUpsertComponent.prototype, "roles", void 0);
    StepUpsertComponent = __decorate([
        Component({
            name: "StepUpsertComponent",
            components: {
                Switches,
                Loader,
                SectionLoader,
            },
        })
    ], StepUpsertComponent);
    return StepUpsertComponent;
})();
export default StepUpsertComponent;
